import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=6f7077b6&scoped=true"
import script from "./ResultsTable.vue?vue&type=script&lang=ts"
export * from "./ResultsTable.vue?vue&type=script&lang=ts"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&id=6f7077b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7077b6",
  null
  
)

export default component.exports